import { createApp } from 'vue';
import { useI18n } from 'vue-i18n';
import type { DeactivationWarning } from '@/api/openapi';
import DeactivationImpactWarningDialog from '@/components/organisms/user/setting/member/DeactivationImpactWarningDialog.vue';
import { useConfirmWithContent } from '@/composable/message-dialog';
import { i18n } from '@/i18n';

/**
 * ユーザー無効化前の影響プレビュー警告ダイアログを表示する composable
 */
export const useDeactivationImpactWarningDialog = () => {
  const { t } = useI18n();
  const { confirmWithContent } = useConfirmWithContent();

  /**
   * 警告ダイアログを表示
   * @returns true: 確認ボタンクリック / false: キャンセル
   */
  const showDialog = async (warnings: DeactivationWarning[]): Promise<boolean> => {
    const container = document.createElement('div');
    const app = createApp(DeactivationImpactWarningDialog, { warnings });

    app.use(i18n);
    app.mount(container);

    try {
      return await confirmWithContent({
        title: t('corpSetting.tab.member.deactivateConfirm.title'),
        content: container,
      });
    } finally {
      app.unmount();
    }
  };

  return { showDialog };
};
